import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { InteractiveContainer } from "../../primitives/InteractiveContainer";

interface SideMenuPanelProps {
  children: ReactNode;
  className?: string;
}

export const SideMenuPanel: FC<SideMenuPanelProps> = ({
  children,
  className,
}) => (
  <div
    className={cx(
      "border-dark-200 jugl__custom-scrollbar h-full w-[240px] overflow-y-auto border-0 border-r border-solid py-8",
      className
    )}
  >
    {children}
  </div>
);

interface SideMenuListProps {
  children: ReactNode;
}

export const SideMenuList: FC<SideMenuListProps> = ({ children }) => (
  <div className="flex flex-col gap-4 px-4">{children}</div>
);

export interface SideMenuListItemProps {
  label: string;
  isSelected: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  onClick: () => void;
}

export const SideMenuListItem: FC<SideMenuListItemProps> = ({
  label,
  isSelected,
  startIcon,
  endIcon,
  onClick,
}) => {
  return (
    <InteractiveContainer
      className={cx(
        "flex h-12 items-center gap-2.5 overflow-hidden rounded-lg px-2 transition-colors",
        isSelected ? "bg-grey-100" : "hover:bg-grey-100 active:bg-grey-200"
      )}
      onClick={onClick}
    >
      {startIcon && <div className="flex shrink-0">{startIcon}</div>}
      <span
        className={cx(
          "font-secondary grow truncate text-sm transition-colors",
          isSelected ? "font-medium text-black" : "font-normal text-[#4F4F4F]"
        )}
        title={label}
      >
        {label}
      </span>
      {endIcon && <div className="flex shrink-0">{endIcon}</div>}
    </InteractiveContainer>
  );
};

export const SideMenuDivider: FC = () => (
  <div className="my-3 h-px w-full shrink-0 bg-[#F2F2F2]" />
);
